<div class="stepper-button" matRipple [class]="{ 'stepper-button-selected': selected }">
  <div class="stepper-button-content">
    <ng-content></ng-content>
  </div>
</div>
